import { ToastType, ToastWidget } from '@tableau/widgets';
import React = require('react');
import { ServerUrls } from '~src/app/ServerUrls';
import { Messages } from '~src/codegen/Localize';
import { Location } from '~src/common/react/Location';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { UserIdentityConflictsService } from '../services/UserIdentityConflictsService';


export interface UserIdentityMigrationBannerStateProps {
  readonly urls: SpacesSiteUrls;
  readonly isSessionMultiSite: boolean;
  readonly isServerAdmin: boolean;
}

export interface UserIdentityMigrationBannerOwnProps { }

export type UserIdentityMigrationBannerProps = UserIdentityMigrationBannerOwnProps & UserIdentityMigrationBannerStateProps;

export interface UserIdentityMigrationBannerState {
  toastId: string;
}

export class UserIdentityMigrationBanner extends React.PureComponent<UserIdentityMigrationBannerProps, UserIdentityMigrationBannerState> {

  public constructor(props: UserIdentityMigrationBannerProps) {
    super(props);
    this.state = {
      toastId: ''
    };
  }

  public componentDidMount() {
    // Only try to show the message for server admins.
    if (this.props.isServerAdmin) {
      this.showInfoToast();
    }
  }

  public componentWillUnmount() {
    if (this.state.toastId) {
      // Just remove the toast when we leave.
      ToastWidget.dismiss(this.state.toastId);
    }
  }

  private showInfoToast() {
    UserIdentityConflictsService.shouldShowIdentityMigrationInfoToast().then((result) => {
      if (result) {
        const toastId = ToastWidget.show({
          toastType: ToastType.Info,
          message: Messages.identityMigration_InfoToast_Message(),
          actionMessage: Messages.identityMigration_InfoToast_ActionMessage(),
          onCloseRequest: () => UserIdentityConflictsService.disableIdentityMigrationInfoToast(),
          onAction: () => this.onAction(toastId),
          testId: 'identity-migration-info-toast',
        });
        this.setState({
          toastId: toastId
        });
      }
    });
  }

  private onAction(toastId: string) {
      ToastWidget.dismiss(toastId);
      UserIdentityConflictsService.disableIdentityMigrationInfoToast().then(() => {
        const identityMigrationUrl = this.props.isSessionMultiSite ?
            ServerUrls.getInstance().allUserIdentitiesPath() : this.props.urls.allUserIdentitiesPath();

        Location.instance.setHash(identityMigrationUrl);
      });
    }

  public render(): JSX.Element {
    return null;
  }

}
